import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "./ui/alert-dialog";
import { useEffect, useState } from "react";

type ModalConfirmComponentProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	message: string;
	timeout?: number;
};

export function ModalConfirmComponent({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	timeout,
}: ModalConfirmComponentProps) {
	const [progress, setProgress] = useState(100);

	useEffect(() => {
		if (!isOpen) return;

		const interval = 100;
		const step = (interval / timeout) * 100;

		const timer = setInterval(() => {
			setProgress((prev) => {
				const nextValue = prev - step;
				if (nextValue <= 0) {
					clearInterval(timer);
					onConfirm();
					return 0;
				}
				return nextValue;
			});
		}, interval);

		return () => {
			clearInterval(timer);
			setProgress(100);
		};
	}, [isOpen, timeout, onConfirm]);

	return (
		<AlertDialog open={isOpen}>
			<AlertDialogContent className="flex flex-col items-baseline flex-1 top-[95%] m-0 pb-52 lg:p-8 w-screen max-w-full lg:max-w-lg mb-2 lg:top-[50%] rounded-t-2xl">
				{timeout && (
					<div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-4">
						<div
							className="h-full bg-green-500 transition-all"
							style={{ width: `${progress}%` }}
						/>
					</div>
				)}

				<AlertDialogHeader className="w-full text-center">
					<AlertDialogTitle>{title}</AlertDialogTitle>
					<AlertDialogDescription>{message}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="flex flex-1 w-full">
					<AlertDialogCancel className="w-full" onClick={onClose}>
						Cancelar
					</AlertDialogCancel>
					<AlertDialogAction className="w-full" onClick={onConfirm}>
						Continuar
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
